import { useCallback, useState } from 'react'

import { tryCallApi } from '../helpers'

export function useTryCallApi<R, T extends Array<any>>(func: (...args: T) => Promise<R>) {
  const [data, setData] = useState<R | undefined>(undefined)
  const [error, setError] = useState<any>(undefined)
  const [isLoading, setIsLoading] = useState(false)

  const callApi = useCallback(
    async (...params: T) => {
      setError(undefined)
      setIsLoading(true)
      const { error, data } = await tryCallApi(func)(...params)
      setError(error)
      setData(data)
      setIsLoading(false)
    },
    [setData, setError, func]
  )

  const clearResponseData = useCallback(() => {
    setData(undefined)
    setError(undefined)
    setIsLoading(false)
  }, [])

  return { data, error, isLoading, callApi, clearResponseData }
}
